import ThemeProvider from "./theme"
import { AnimatePresence } from "framer-motion"
import { Switch, Route } from "react-router"
import { BrowserRouter } from "react-router-dom"
import { createBrowserHistory } from "history"
import { Provider as StoreProvider } from "react-redux"
import { I18nextProvider } from "react-i18next"
import Landing from "./screens/Landing"
import createStore from "./state/store"
import i18n from "./i18n/i18n-config"
import DependencyProvider from "./components/DependencyProvider"
import { primaryRoutes } from "./routes"
import SalesInfoPreload from "./SalesInfoPreload"
import dependencies from "./dependencies"
import NavigationMenu from "./components/NavigationMenu"
import RouteBroadcaster from "./components/RouteBroadcaster"
// import ZustandBroadcaster from "./components/ApartmentFinder/State/ZustandBroadcaster"
// import POIZustandBroadcaster from "./components/ApartmentFinder/State/POIZustandBroadcaster"
import LightsBroadcaster from "./components/LightsBroadcaster"
import { useEffect } from "react"
import { useStore } from "./components/ApartmentFinder/State/Store"
import ShareApartments from "./screens/ShareApartments"
import Explore from "./screens/Explore"
import Broadcasters from "./components/ApartmentFinder/State/Broadcasters"
import useScreenSaver from "./state/useScreenSaver"

const history = createBrowserHistory()
const store = createStore(dependencies)

const basename = "/"
//TEST
// export const ApartmentSheetURL =
//   "https://docs.google.com/spreadsheets/d/e/2PACX-1vQo44ohziBIVvnqIsLhdpnptQzdIveR5tUh2G3s9voBGzaQro_Ea3szNGB0BzQJ-5tQz1LdXfzaE10X/pub?gid=2101922135&single=true&output=csv"
// LIVE
export const ApartmentSheetURL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vQo44ohziBIVvnqIsLhdpnptQzdIveR5tUh2G3s9voBGzaQro_Ea3szNGB0BzQJ-5tQz1LdXfzaE10X/pub?output=csv"

function App() {
  useScreenSaver(1000 * 60 * 5)

  const setApartments = useStore(state => state.setApartments)
  const isShare = useStore(state => state.isShare)
  useEffect(() => {
    fetch(ApartmentSheetURL)
      .then(response => {
        response.text().then(text => {
          const data = text.split("\r\n").map(line => line.split(","))
          const header = data[1]
          const apartmentsLines = data.slice(2)
          const apartments = []
          for (let line of apartmentsLines) {
            const apartment = {}
            for (let x = 0; x < line.length; x++) {
              apartment[header[x]] = line[x]
            }
            apartments.push(apartment)
          }
          setApartments(apartments)
          localStorage.setItem("apartments", JSON.stringify(apartments))
        })
      })
      .catch(() => {
        setApartments(JSON.parse(localStorage.getItem("apartments")))
      })
  }, [])

  return (
    <ThemeProvider>
      <DependencyProvider dependencies={dependencies}>
        <I18nextProvider i18n={i18n}>
          <StoreProvider store={store}>
            <BrowserRouter history={history} basename={basename}>
              <SalesInfoPreload />
              <AnimatePresence>
                <Switch>
                  <Route exact path={basename} component={Landing} />
                  {primaryRoutes.map(({ path, component }) => (
                    <Route key={path} path={path} component={component} />
                  ))}
                  <Route
                    path={"/share_apartments"}
                    component={ShareApartments}
                  />
                </Switch>
              </AnimatePresence>
              {process.env.REACT_APP_MARKETING_SUITE && <RouteBroadcaster />}
              {/* {process.env.REACT_APP_MARKETING_SUITE && <ZustandBroadcaster />} */}
              {process.env.REACT_APP_MARKETING_SUITE && <Broadcasters />}
              {/* {process.env.REACT_APP_MARKETING_SUITE && (
                <POIZustandBroadcaster />
              )} */}
              <LightsBroadcaster />
              {/* {process.env.REACT_APP_ROLE === "sender" && <LightsBroadcaster />} */}
              {!isShare && (
                <>
                  <NavigationMenu routes={primaryRoutes} />
                  <Explore />
                </>
              )}
            </BrowserRouter>
          </StoreProvider>
        </I18nextProvider>
      </DependencyProvider>
    </ThemeProvider>
  )
}

export default App
